import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import PopularSection from './components/PopularSection';
import LatestSection from './components/LatestSection';
import CategorySection from './components/CategorySection';
import FeatureSection from './components/FeatureSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  const schemaData = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '韩漫在线-免费韩国漫画大全-韩漫全集下拉式阅读-韩漫网',
    description: '韩漫网提供免费韩国漫画大全，支持全集下拉式阅读，让您在线畅读各种韩漫，享受便捷的浏览功能，随时随地探索人气作品并追更最新内容。',
    url: 'http://ccbcht.com/',
    isPartOf: {
      '@type': 'WebSite',
      name: '韩漫在线',
      url: 'http://ccbcht.com/',
    },
    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: '首页',
          item: 'http://ccbcht.com/',
        },
      ],
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <PopularSection />
        <LatestSection />
        <CategorySection />
        <FeatureSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}